export default __webpack_public_path__ + "static/media/83.266341d4.jpg";